<script>
	import Icon from "../icons/Icon.svelte";

	export let couriers = [];
	export let nextCourier = null;
	export let formatCurrency = (val) => Number(val || 0).toFixed(2).replace(".", ",");

	export let onOpenCreateModal = () => {};
	export let onOpenSettlementTab = () => {};
	export let onCopyPortalLink = () => {};
	export let onSendPortalWhatsApp = () => {};
	export let onReturnFromDelivery = () => {};
	export let onMoveInQueue = () => {};
	export let onToggleStatus = () => {};
</script>

<!-- Banner de Destaque Premium: Próximo da Fila -->
{#if nextCourier}
	<div class="next-courier-banner">
		<div class="next-badge-icon">
			<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>
		</div>
		<div class="next-info">
			<div class="next-tag-row">
				<span class="next-tag">PRÓXIMO A SAIR NA ROLETA</span>
				<span class="next-pos-pill">#1 na fila de despacho</span>
			</div>
			<h3 class="next-name">{nextCourier.name}</h3>
			<div class="next-meta-row">
				<span class="next-vehicle-chip">
					<Icon name={nextCourier.vehicle_type === 'bike' ? 'bike' : nextCourier.vehicle_type === 'carro' ? 'car' : 'motorcycle'} size={13} />
					{nextCourier.vehicle_type === 'bike' ? 'Bicicleta' : nextCourier.vehicle_type === 'carro' ? 'Carro' : 'Moto'}
					{#if nextCourier.plate}
						<span class="next-plate">[{nextCourier.plate}]</span>
					{/if}
				</span>
				<span class="next-fee-chip">Taxa Padrão: R$ {formatCurrency(nextCourier.default_fee)}</span>
				<span class="next-deliveries-chip">{nextCourier.todayMetrics?.deliveries || 0} viagens hoje</span>
			</div>
		</div>
		<div class="next-right-action">
			<button
				type="button"
				class="btn-next-action"
				on:click={() => onOpenSettlementTab(nextCourier)}
				title="Consultar acerto financeiro deste entregador"
			>
				<Icon name="wallet" size={14} />
				<span>Ver Acerto R$</span>
			</button>
		</div>
	</div>
{:else}
	<div class="empty-queue-alert">
		<div class="empty-alert-icon">
			<Icon name="clock" size={20} color="#D97706" />
		</div>
		<div class="empty-alert-text">
			<strong>Nenhum motoboy disponível na fila no momento!</strong>
			<p>Ative um entregador como "Disponível" na lista abaixo para organizar o despacho da roleta.</p>
		</div>
	</div>
{/if}

{#if couriers.length === 0}
	<div class="empty-state-box">
		<div class="empty-state-icon"><Icon name="users" size={32} /></div>
		<h3>Nenhum entregador cadastrado</h3>
		<p>Cadastre sua equipe de motoboys para iniciar a roleta de distribuição de pedidos.</p>
		<button type="button" class="btn-primary-action" on:click={onOpenCreateModal}>
			+ Cadastrar Primeiro Entregador
		</button>
	</div>
{:else}
	<!-- Grid da Fila de Motoboys -->
	<div class="queue-grid">
		{#each couriers as courier (courier.id)}
			<div class="queue-card {courier.status === 'busy' ? 'busy' : courier.status === 'offline' ? 'offline' : 'available'} {courier.queue_position === 1 && courier.status === 'available' ? 'is-first' : ''}">
				<!-- Cabeçalho do Card -->
				<div class="queue-card-header">
					<div class="position-badge">
						{#if courier.status === 'available'}
							<span class="pos-number">#{courier.queue_position}</span>
							<span class="pos-label">na fila</span>
						{:else if courier.status === 'busy'}
							<span class="pos-busy">
								<Icon name="motorcycle" size={13} />
								<span>NA RUA</span>
							</span>
						{:else}
							<span class="pos-offline">PAUSA</span>
						{/if}
					</div>

					<div class="status-pill {courier.status}">
						<span class="dot"></span>
						<span>{courier.status === 'available' ? 'Disponível' : courier.status === 'busy' ? 'Em Entrega' : 'Pausado'}</span>
					</div>
				</div>

				<!-- Corpo do Card -->
				<div class="queue-card-body">
					<div class="courier-main-info">
						<h4 class="courier-name">{courier.name}</h4>
						<div class="courier-phone-row">
							{#if courier.phone}
								<div class="courier-phone-actions">
									<a href="https://wa.me/55{courier.phone.replace(/\D/g, '')}" target="_blank" rel="noreferrer" class="courier-wa-link" title="Conversar no WhatsApp">
										<Icon name="whatsapp" size={13} color="#10B981" />
										<span>{courier.phone}</span>
									</a>
									<div class="portal-quick-actions">
										<button type="button" class="btn-portal-share" on:click={() => onCopyPortalLink(courier)} title="Copiar link do portal web/PWA do motoboy">
											<Icon name="copy" size={11} />
											<span>Copiar Link</span>
										</button>
										<button type="button" class="btn-portal-share wa" on:click={() => onSendPortalWhatsApp(courier)} title="Enviar link do portal web/PWA pelo WhatsApp">
											<Icon name="send" size={11} />
											<span>WhatsApp</span>
										</button>
									</div>
								</div>
							{:else}
								<span class="text-muted">Sem telefone cadastrado</span>
							{/if}
						</div>
					</div>

					<div class="courier-vehicle-tag">
						<span class="vehicle-pill">
							<Icon name={courier.vehicle_type === 'bike' ? 'bike' : courier.vehicle_type === 'carro' ? 'car' : 'motorcycle'} size={13} />
							<span>{courier.vehicle_type === 'bike' ? 'Bicicleta' : courier.vehicle_type === 'carro' ? 'Carro' : 'Moto'}</span>
						</span>
						{#if courier.plate}
							<span class="plate-tag">{courier.plate}</span>
						{/if}
					</div>

					<!-- Métricas do Dia do Entregador -->
					<div class="courier-day-stats">
						<div class="stat-col">
							<span class="stat-label">Viagens hoje</span>
							<strong class="stat-val">{courier.todayMetrics?.deliveries || 0}</strong>
						</div>
						<div class="stat-col">
							<span class="stat-label">Dinheiro rua</span>
							<strong class="stat-val text-green">R$ {formatCurrency(courier.todayMetrics?.cashCollected)}</strong>
						</div>
						<div class="stat-col">
							<span class="stat-label">Taxas ganhas</span>
							<strong class="stat-val text-orange">R$ {formatCurrency(courier.todayMetrics?.feesEarned)}</strong>
						</div>
					</div>
				</div>

				<!-- Rodapé de Ações do Cartão -->
				<div class="queue-card-actions">
					{#if courier.status === 'busy'}
						<button
							type="button"
							class="btn-card-action return-btn"
							on:click={() => onReturnFromDelivery(courier)}
							title="Marcar que o motoboy retornou à loja (vai para o fim da fila da roleta)"
						>
							<Icon name="motorcycle" size={14} />
							<span>Confirmar Retorno</span>
						</button>
					{:else}
						<div class="reorder-btns">
							<button
								type="button"
								class="btn-arrow"
								disabled={courier.queue_position <= 1 || courier.status !== 'available'}
								on:click={() => onMoveInQueue(courier, 'up')}
								title="Subir posição na fila"
								aria-label="Subir posição na fila"
							>
								▲
							</button>
							<button
								type="button"
								class="btn-arrow"
								disabled={courier.status !== 'available'}
								on:click={() => onMoveInQueue(courier, 'down')}
								title="Descer posição na fila"
								aria-label="Descer posição na fila"
							>
								▼
							</button>
						</div>

						<button
							type="button"
							class="btn-card-action toggle-btn {courier.status === 'available' ? 'pause' : 'resume'}"
							on:click={() => onToggleStatus(courier)}
						>
							{#if courier.status === 'available'}
								<Icon name="pause" size={13} />
								<span>Pausar</span>
							{:else}
								<Icon name="play" size={13} />
								<span>Entrar na Fila</span>
							{/if}
						</button>
					{/if}

					<button
						type="button"
						class="btn-card-action settle-btn"
						on:click={() => onOpenSettlementTab(courier)}
						title="Abrir fechamento e acerto financeiro do dia"
					>
						<Icon name="wallet" size={13} />
						<span>Acerto R$</span>
					</button>
				</div>
			</div>
		{/each}
	</div>
{/if}

<style>
	.next-courier-banner {
		background: linear-gradient(135deg, #0F172A, #1E293B);
		color: #FFFFFF;
		border-radius: var(--radius-lg, 16px);
		padding: 20px 24px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 20px;
		margin-bottom: 24px;
		box-shadow: var(--shadow-modal, 0 10px 25px rgba(15, 23, 42, 0.15));
		border: 1px solid rgba(255, 255, 255, 0.08);
	}

	.next-badge-icon {
		width: 46px;
		height: 46px;
		border-radius: var(--radius-md, 12px);
		background: var(--brand-primary, #FF6A00);
		display: flex;
		align-items: center;
		justify-content: center;
		color: #FFFFFF;
		flex-shrink: 0;
		box-shadow: 0 4px 14px rgba(255, 106, 0, 0.4);
	}

	.next-info {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 4px;
	}

	.next-tag-row {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.next-tag {
		font-size: 10.5px;
		font-weight: 800;
		letter-spacing: 0.8px;
		color: #FF9B54;
		text-transform: uppercase;
	}

	.next-pos-pill {
		background: rgba(255, 106, 0, 0.18);
		border: 1px solid rgba(255, 106, 0, 0.4);
		color: #FFAA70;
		font-size: 11px;
		font-weight: 700;
		padding: 1px 8px;
		border-radius: 999px;
	}

	.next-name {
		font-size: 19px;
		font-weight: 900;
		margin: 0;
		letter-spacing: -0.2px;
	}

	.next-meta-row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 12px;
		font-size: 12.5px;
		color: #94A3B8;
	}

	.next-vehicle-chip {
		display: inline-flex;
		align-items: center;
		gap: 5px;
		color: #E2E8F0;
		font-weight: 600;
	}

	.next-plate {
		color: #FF9B54;
		font-weight: 800;
	}

	.next-fee-chip, .next-deliveries-chip {
		background: rgba(255, 255, 255, 0.08);
		padding: 2px 8px;
		border-radius: 4px;
		font-size: 11.5px;
		color: #CBD5E1;
	}

	.btn-next-action {
		background: rgba(255, 255, 255, 0.1);
		color: #FFFFFF;
		border: 1px solid rgba(255, 255, 255, 0.2);
		padding: 10px 16px;
		border-radius: var(--radius-md, 10px);
		font-size: 13px;
		font-weight: 700;
		cursor: pointer;
		display: inline-flex;
		align-items: center;
		gap: 8px;
		transition: all var(--transition-fast, 0.15s ease);
		white-space: nowrap;
	}

	.btn-next-action:hover {
		background: rgba(255, 255, 255, 0.18);
		border-color: #FFFFFF;
	}

	.empty-queue-alert {
		background: var(--semantic-warning-soft, #FFFBEB);
		border: 1px solid #FDE68A;
		color: #92400E;
		border-radius: var(--radius-lg, 16px);
		padding: 18px 22px;
		display: flex;
		align-items: center;
		gap: 16px;
		margin-bottom: 24px;
	}

	.empty-alert-icon {
		width: 40px;
		height: 40px;
		border-radius: 10px;
		background: #FEF3C7;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	.empty-alert-text strong {
		display: block;
		font-size: 14px;
		margin-bottom: 2px;
	}

	.empty-alert-text p {
		margin: 0;
		font-size: 13px;
		color: #B45309;
	}

	.queue-grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
		gap: 18px;
	}

	.queue-card {
		background: var(--neutral-surface, #FFFFFF);
		border: 1px solid var(--neutral-border, #E2E8F0);
		border-radius: var(--radius-lg, 16px);
		padding: 18px;
		display: flex;
		flex-direction: column;
		gap: 14px;
		box-shadow: var(--shadow-card, 0 1px 3px rgba(15, 23, 42, 0.06));
		transition: transform var(--transition-fast, 0.15s ease), box-shadow var(--transition-fast, 0.15s ease), border-color var(--transition-fast, 0.15s ease);
		position: relative;
	}

	.queue-card:hover {
		transform: translateY(-2px);
		box-shadow: var(--shadow-card-hover, 0 6px 14px rgba(15, 23, 42, 0.08));
	}

	.queue-card.is-first {
		border: 2px solid var(--brand-primary, #FF6A00);
		box-shadow: 0 4px 16px rgba(255, 106, 0, 0.14);
	}

	.queue-card.busy {
		background: #F8FAFC;
		border-left: 4px solid var(--semantic-info, #2563EB);
	}

	.queue-card.offline {
		opacity: 0.7;
		background: #F8FAFC;
	}

	.queue-card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.position-badge {
		display: flex;
		align-items: baseline;
		gap: 5px;
	}

	.pos-number {
		font-size: 19px;
		font-weight: 900;
		color: var(--brand-primary, #FF6A00);
	}

	.pos-label {
		font-size: 11px;
		font-weight: 700;
		color: var(--text-secondary, #475569);
		text-transform: uppercase;
		letter-spacing: 0.4px;
	}

	.pos-busy {
		font-size: 11.5px;
		font-weight: 800;
		color: var(--semantic-info, #2563EB);
		background: var(--semantic-info-soft, #EFF6FF);
		padding: 4px 8px;
		border-radius: 6px;
		display: inline-flex;
		align-items: center;
		gap: 5px;
		border: 1px solid #BFDBFE;
	}

	.pos-offline {
		font-size: 11px;
		font-weight: 700;
		color: var(--text-secondary, #64748B);
		background: #F1F5F9;
		padding: 3px 8px;
		border-radius: 6px;
		border: 1px solid #E2E8F0;
	}

	.status-pill {
		font-size: 11px;
		font-weight: 700;
		padding: 3px 9px;
		border-radius: var(--radius-full, 9999px);
		display: inline-flex;
		align-items: center;
		gap: 6px;
	}

	.status-pill.available { background: var(--semantic-success-soft, #ECFDF5); color: var(--semantic-success, #059669); border: 1px solid #A7F3D0; }
	.status-pill.busy { background: var(--semantic-info-soft, #EFF6FF); color: var(--semantic-info, #2563EB); border: 1px solid #BFDBFE; }
	.status-pill.offline { background: #F1F5F9; color: #64748B; border: 1px solid #CBD5E1; }

	.status-pill .dot {
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background: currentColor;
	}

	.queue-card-body {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.courier-name {
		font-size: 16px;
		font-weight: 800;
		color: var(--text-primary, #0F172A);
		margin: 0;
		letter-spacing: -0.2px;
	}

	.courier-phone-row {
		margin-top: 2px;
	}

	.courier-wa-link {
		color: #15803D;
		text-decoration: none;
		font-size: 12px;
		font-weight: 600;
		display: inline-flex;
		align-items: center;
		gap: 5px;
		transition: opacity 0.15s ease;
	}

	.courier-wa-link:hover {
		text-decoration: underline;
		opacity: 0.85;
	}

	.portal-quick-actions {
		display: flex;
		align-items: center;
		gap: 6px;
		flex-wrap: wrap;
		margin-top: 4px;
	}

	.btn-portal-share {
		background: #1E293B;
		color: #E2E8F0;
		border: 1px solid #334155;
		border-radius: 6px;
		padding: 3px 8px;
		font-size: 11px;
		font-weight: 600;
		display: inline-flex;
		align-items: center;
		gap: 4px;
		cursor: pointer;
		transition: all 0.15s ease;
	}

	.btn-portal-share:hover {
		background: #334155;
		color: #FFFFFF;
	}

	.btn-portal-share.wa {
		background: rgba(16, 185, 129, 0.12);
		border-color: rgba(16, 185, 129, 0.3);
		color: #10B981;
	}

	.btn-portal-share.wa:hover {
		background: rgba(16, 185, 129, 0.25);
		color: #059669;
	}

	.courier-vehicle-tag {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-top: 4px;
	}

	.vehicle-pill {
		background: #F1F5F9;
		color: var(--text-secondary, #475569);
		font-size: 12px;
		font-weight: 600;
		padding: 3px 8px;
		border-radius: 6px;
		display: inline-flex;
		align-items: center;
		gap: 5px;
	}

	.plate-tag {
		background: #0F172A;
		color: #FFFFFF;
		font-size: 11px;
		font-weight: 800;
		padding: 2px 7px;
		border-radius: 4px;
		letter-spacing: 0.5px;
	}

	.courier-day-stats {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 8px;
		background: #F8FAFC;
		border: 1px solid var(--neutral-border, #E2E8F0);
		border-radius: var(--radius-md, 10px);
		padding: 10px 8px;
		margin-top: 8px;
		text-align: center;
	}

	.stat-col {
		display: flex;
		flex-direction: column;
		gap: 2px;
	}

	.stat-label {
		font-size: 10px;
		font-weight: 700;
		color: var(--text-muted, #94A3B8);
		text-transform: uppercase;
		letter-spacing: 0.3px;
	}

	.stat-val {
		font-size: 13px;
		font-weight: 800;
		color: var(--text-primary, #0F172A);
	}

	.queue-card-actions {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-top: auto;
		padding-top: 14px;
		border-top: 1px solid var(--neutral-border-subtle, #F1F5F9);
	}

	.reorder-btns {
		display: flex;
		gap: 4px;
	}

	.btn-arrow {
		background: #F8FAFC;
		border: 1px solid var(--neutral-border, #E2E8F0);
		width: 30px;
		height: 30px;
		border-radius: 6px;
		font-size: 11px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		color: var(--text-secondary, #475569);
		transition: all 0.15s ease;
	}

	.btn-arrow:hover:not(:disabled) {
		background: var(--neutral-surface-hover, #F1F5F9);
		color: var(--text-primary, #0F172A);
		border-color: #CBD5E1;
	}

	.btn-arrow:disabled {
		opacity: 0.3;
		cursor: not-allowed;
	}

	.btn-card-action {
		flex: 1;
		padding: 8px 10px;
		border-radius: 8px;
		font-size: 12px;
		font-weight: 700;
		cursor: pointer;
		border: none;
		transition: all var(--transition-fast, 0.15s ease);
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 6px;
		text-align: center;
	}

	.return-btn {
		background: var(--semantic-success, #059669);
		color: #FFFFFF;
	}

	.return-btn:hover {
		background: #047857;
	}

	.toggle-btn.pause {
		background: #F8FAFC;
		color: var(--text-secondary, #475569);
		border: 1px solid var(--neutral-border, #CBD5E1);
	}

	.toggle-btn.pause:hover {
		background: #F1F5F9;
		color: var(--text-primary, #0F172A);
	}

	.toggle-btn.resume {
		background: var(--semantic-success-soft, #ECFDF5);
		color: var(--semantic-success, #059669);
		border: 1px solid #A7F3D0;
	}

	.toggle-btn.resume:hover {
		background: #D1FAE5;
	}

	.settle-btn {
		background: var(--brand-primary-soft, #FFF7ED);
		color: var(--brand-primary, #FF6A00);
		border: 1px solid #FED7AA;
	}

	.settle-btn:hover {
		background: #FFEDD5;
	}

	.btn-primary-action {
		background: var(--brand-primary, #FF6A00);
		color: #FFFFFF;
		border: none;
		border-radius: var(--radius-md, 8px);
		padding: 10px 18px;
		font-size: 13px;
		font-weight: 800;
		cursor: pointer;
		display: inline-flex;
		align-items: center;
		gap: 8px;
		transition: background var(--transition-fast, 0.15s ease), transform var(--transition-fast, 0.15s ease);
		box-shadow: 0 2px 8px rgba(255, 106, 0, 0.25);
	}

	.btn-primary-action:hover {
		background: var(--brand-primary-hover, #E85A00);
		transform: translateY(-1px);
	}

	.empty-state-box {
		padding: 48px 24px;
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 12px;
	}

	.empty-state-icon {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		background: #F1F5F9;
		color: #94A3B8;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 4px;
	}

	.empty-state-box h3 {
		margin: 0;
		font-size: 17px;
		font-weight: 800;
		color: var(--text-primary, #0F172A);
	}

	.empty-state-box p {
		margin: 0;
		font-size: 13.5px;
		color: var(--text-secondary, #64748B);
		max-width: 380px;
	}

	.text-green { color: #16A34A !important; }
	.text-orange { color: #EA580C !important; }
	.text-muted { color: var(--text-muted, #94A3B8); }
</style>
